<template>
    <v-layout align-center justify-center class="attpicviewer_bg">
        <v-toolbar fixed flat class="transparent" style="color:white;">
          <v-spacer></v-spacer>
          <v-toolbar-items>       
              <v-btn dark flat @click="closeDialog">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm12>           
            <div :class="isMobile?'img-viewer-mobile':'img-viewer'" >
                <v-img v-if="image && image.orientation && image.orientation=='portrait'" ref="avatar" @click="closeDialog" class="mx-auto portrait"></v-img>
                <v-img v-else ref="avatar" @click="closeDialog"></v-img>
            </div> 
        </v-flex>
    </v-layout>
</template>
<script>
export default {
    data() {
        return {}
    },   
    props: ['image'],
    methods: {
        viewPic(image) {
            const img = this.image?this.image.fileName:image
            this.$refs.avatar.src = require(`@/assets/landing/${img}`)
        },
        closeDialog() {
            this.$emit('update:dialogPicViewer', false)
        }
    },
    created() {},
    computed: {
        attPicPath() {
            return process.env.VUE_APP_ATTPIC_URL
        }
    }
}
</script>
<style scoped>
.attpicviewer_bg {
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9)
}
.img-viewer {
    width:1000px;
    margin-left: auto;
    margin-right: auto;
}
.img-viewer-mobile {
    width:100%;
    margin-left: auto;
    margin-right: auto;
}
.portrait {
    height:500px;
    width:250px;
}
</style>